import Vue from 'vue';
import ElementUI from 'element-ui';
import directiveDialog from '@/directive/dialogDrag';
import filters from '@/util/filter';

import MyTable from '@/components/MyTable';
import MyFrontTable from '@/components/MyFrontTable';
import MyDialog from '@/components/MyDialog';
import MyDrawer from '@/components/MyDrawer';
import MySelect from '@/components/MySelect';
import MyPageSelect from '@/components/MyPageSelect';


import CommonAdd from '@/components/CommonAdd';
import CommonDetail from '@/components/CommonDetail';
import CommonLeadingIn from '@/components/CommonLeadingIn';
import CommCollect from "../components/CommCollect";
import CommRead from "../components/CommRead";
import lsAdminDialog from '@/components/lsAdminDialog';
import lsAdminTable from '@/components/lsAdminTable';
import lsUpload from '@/components/lsUpload';

import LsCalendar from '@/components/LsCalendar';
import LsPopup from '@/components/LsPopup';


import CommonSync from '@/components/CommonSync';

import commonFuzzy from '@/components/fuzzy/common-fuzzy'
import fuzzyCatalog from '@/components/fuzzy/fuzzy-catalog'
import fuzzyAdvertisingPlace from '@/components/fuzzy/fuzzy-advertisingPlace'
import fuzzyTag from '@/components/fuzzy/fuzzy-tag'


Vue.use(ElementUI, {zIndex: 300, size: 'mini'});
Vue.directive(directiveDialog.name, directiveDialog);

// filter
Object.keys(filters).forEach(key => {
    Vue.filter(key, filters[key]);
})

Vue.component('MyTable', MyTable);
Vue.component('MyFrontTable', MyFrontTable);
Vue.component('MyDialog', MyDialog);
Vue.component('MyDrawer', MyDrawer);
Vue.component('MySelect', MySelect);
Vue.component('MyPageSelect', MyPageSelect);

Vue.component('CommonAdd', CommonAdd);
Vue.component('CommonDetail', CommonDetail);
Vue.component('CommonLeadingIn', CommonLeadingIn);
Vue.component('CommCollect', CommCollect);
Vue.component('CommRead', CommRead);
Vue.component('lsAdminDialog', lsAdminDialog);
Vue.component('lsAdminTable', lsAdminTable);
Vue.component('lsUpload', lsUpload);
Vue.component('CommonSync', CommonSync);

Vue.component('LsCalendar', LsCalendar);
Vue.component('LsPopup', LsPopup);

Vue.component('commonFuzzy', commonFuzzy);
Vue.component('fuzzyCatalog', fuzzyCatalog);
Vue.component('fuzzyAdvertisingPlace',fuzzyAdvertisingPlace);
Vue.component('fuzzyTag',fuzzyTag);


Vue.config.productionTip = false;
